import {
  REQUEST_REACTION_USERS,
  FAIL_RECEIVE_REACTION_USERS,
  RECEIVE_REACTION_USERS,
  FINISHED_REACTION_USERS,
} from 'shared/actionTypes';

function users(state = [], action) {
  switch (action.type) {
  case RECEIVE_REACTION_USERS:
    const { users: nextUsers } = action.payload;
    return [
      ...state,
      ...nextUsers,
    ];
  default:
    return state;
  }
}

function reaction(state = {
  isError: false,
  isFetching: false,
  isFinished: false,
  nextReactionDate: null,
  users: [],
}, action) {
  switch (action.type) {
  case REQUEST_REACTION_USERS:
    return Object.assign({}, state, {
      isFetching: true,
    });
  case FAIL_RECEIVE_REACTION_USERS:
    return Object.assign({}, state, {
      isError: true,
      isFetching: false,
    });
  case RECEIVE_REACTION_USERS:
    const { firstReactionDate } = action.payload;
    return Object.assign({}, state, {
      isFetching: false,
      nextReactionDate: firstReactionDate,
      users: users(state.users, action),
    });
  case FINISHED_REACTION_USERS:
    return Object.assign({}, state, {
      isFinished: true,
    });
  default:
    return state;
  }
}

function reactionDetails(state = {}, action) {
  switch (action.type) {
  case REQUEST_REACTION_USERS:
  case FAIL_RECEIVE_REACTION_USERS:
  case RECEIVE_REACTION_USERS:
  case FINISHED_REACTION_USERS:
    const { reaction: reactionType } = action.payload;
    return Object.assign({}, state, {
      [reactionType]: reaction(state[reactionType], action),
    });
  default:
    return state;
  }
}

export default function contentReactionDetails(state = {}, action) {
  switch (action.type) {
  case REQUEST_REACTION_USERS:
  case FAIL_RECEIVE_REACTION_USERS:
  case RECEIVE_REACTION_USERS:
  case FINISHED_REACTION_USERS:
    const { communityContentType, communityContentRelatedId } = action.payload;
    const communityContentIdKey = `${communityContentType}-${communityContentRelatedId}`;
    const { reactionDetails: previousReactionDetails } = state[communityContentIdKey] || {};

    return Object.assign({}, state, {
      [communityContentIdKey]: {
        reactionDetails: reactionDetails(previousReactionDetails, action),
      },
    });
  default:
    return state;
  }
}
